module.exports = __webpack_public_path__ + "static/media/mqtt_protocol_en.ed3f18ed.md";